import styled, { css } from 'styled-components';
import { createReadableClass, getColorWithAlpha } from '@elfsight/widget-utils';
import { CLASS_COMPONENT } from '../../common';

type SectionAlign = 'center' | 'flex-start';

export const Section = styled.div.attrs<{
  $color?: string;
  $withTopDivider?: boolean;
  $withBottomDivider?: boolean;
  $withoutTopPadding?: boolean;
  $withoutBottomPadding?: boolean;
  $classModifier?: string;
  $align?: SectionAlign;
  $gap?: number;
  $disabled?: boolean;
  $stretch?: boolean;
}>(({ $classModifier }) => ({
  className: createReadableClass({
    component: CLASS_COMPONENT,
    element: 'section',
    modifier: $classModifier
  })
}))`
  display: flex;
  flex-direction: column;

  padding: 0;

  border-radius: 0;
  border-style: solid;
  border-width: 0;

  color: inherit;

  ${({
    $color,
    $withTopDivider,
    $withBottomDivider,
    $withoutTopPadding,
    $withoutBottomPadding,
    $align = 'center',
    $gap = 8,
    $disabled = false,
    $stretch = true
  }) => css`
    ${$color &&
    `
      color: ${$color};
      border-color: ${getColorWithAlpha($color, 0.1)};
    `}
    ${$withTopDivider && 'border-top-width: 1px;'}
    ${$withBottomDivider && 'border-bottom-width: 1px;'}
    ${!$withoutTopPadding && 'padding-top: 20px;'}
    ${!$withoutBottomPadding && 'padding-bottom: 20px;'}
    ${`
      align-items: ${$align}; 
      justify-content: ${$align};`}
    ${`gap: ${$gap}px;`}
    ${$disabled && 'pointer-events: none;'}
    ${$stretch && 'width: 100%;'}
  `}
`;
